module.exports = __webpack_public_path__ + "static/img/tj5.5aac79c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tj5.png
// module id = j/0V
// module chunks = 1